<div class="page">
  <header class="page__header">
    <h1 class="page__title" i18n="@@home.page.header.title">Home</h1>
  </header>
  <div class="page__content">
    <carehub-widget-dashboard></carehub-widget-dashboard>
  </div>
</div>
